import { cva, type VariantProps } from 'class-variance-authority'
import type { ButtonHTMLAttributes } from 'react'
import { cn } from '../cn'

export const buttonVariants = cva(
  'font-bold transition-colors disabled:pointer-events-none',
  {
    variants: {
      variant: {
        primary: 'bg-[#176361] text-white disabled:bg-[#639897]',
        ghost: 'text-[#888] disabled:opacity-50',
      },
      size: {
        lg: 'h-[52px] w-full rounded-full',
        sm: 'h-9 text-base',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'lg',
    },
  },
)

export interface ButtonProps
  extends
    ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export function Button({ variant, size, className, ...props }: ButtonProps) {
  return (
    <button
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  )
}
